import { render, staticRenderFns } from "./TabNoteDetail.vue?vue&type=template&id=f2fe9cd2&scoped=true"
import script from "./TabNoteDetail.vue?vue&type=script&lang=js"
export * from "./TabNoteDetail.vue?vue&type=script&lang=js"
import style0 from "./TabNoteDetail.vue?vue&type=style&index=0&id=f2fe9cd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2fe9cd2",
  null
  
)

export default component.exports